module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-footer": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("A " + _vm._s(_vm.policy) + " policy was enacted\n        "), (!_vm.args.government) ? [_vm._v("by anarchy")] : _vm._e()], 2), (_vm.args.government) ? _c('government', {
    attrs: {
      "government": _vm.args.government
    }
  }) : _vm._e(), _c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('policy-card', {
    staticClass: "card",
    attrs: {
      "basis": "long",
      "policy": _vm.args.policy
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ec2f64a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/events/events/policy/details.vue
// module id = 343
// module chunks = 0